import React from 'react';
import SkeletonLoadingBox from '../common/SkeletonLoadingBox';

function ListingItemSkeleton(props) {
    const { key } = props;

    return (
        <div className='store-list__item' key={key}>
            <span className='store-list__heading'>
                <SkeletonLoadingBox width='50%' height={16} />
            </span>
            <div className='store-list__content text-box'>
                <SkeletonLoadingBox
                    width='45%'
                    height={17}
                    style={{ marginBottom: 3 }}
                />
                <SkeletonLoadingBox
                    width='30%'
                    height={17}
                    style={{ marginBottom: 3 }}
                />
                <SkeletonLoadingBox width='70%' height={17} />
            </div>
        </div>
    );
}

export default ListingItemSkeleton;
